import { useEffect, useState } from "react"
import { CircularProgress, Container, Grid } from "@mui/material"
import { I18nextProvider } from 'react-i18next'
import i18config from '../../../helpers/i18n'
import { ThemeProvider } from '@mui/material'
import theme from '../../../helpers/theme'
import RecurringPaymentFlow from "../../recurring-payment-flow/RecurringPaymentFlow/RecurringPaymentFlow"
import MembershipPaymentPage from "../MembershipPaymentPage/MembershipPaymentPage"
import ArrearsPaymentFlow, { ArrearsRoute } from "../../arrears-payment-flow/ArrearsPaymentFlow/ArrearsPaymentFlow"
import { StoreProvider } from "../../../store/membership/MembershipSignupStore"
import { initialState, membershipReducer } from "../../../store/membership/MembershipReducer"
import {
    getMembershipDetails,
    MembershipDetail,
} from "../../../services/ntuc/memberService/membershipDetails"
import { useCookies } from "react-cookie"
import { AppCookies } from "../../../helpers/cookies"
import MembershipSelection from "../MembershipSelectionPage/MembershipSelection"

export type MembershipPaymentRouteProps = {
    onNavigateTo: (newRoute: MembershipPaymentRoute) => void
}

enum MembershipPaymentRoute {
    Main,
    Recurring,
    MembershipFeePayment,
    RetryUpfrontPayment,
    MembershipSelection
}

// const mockMembershipResponse= {
//     memberships: [
//         {
//             id: 4255,
//             createdDttm: `2025-08-20T07:22:41.935Z`,
//             membershipTypeCode: `GB`,
//             modifiedDttm: `2025-08-20T08:40:33.452Z`,
//             status: `ACTIVE`,
//             unionCode: `BFSU`,
//             unionName: `Banking and Financial Services Union`,
//             lastPaymentStartDate: `2025-08-01T00:00:00.000Z`,
//             lastPaymentEndDate: `2025-08-31T00:00:00.000Z`,
//             nameOnCard: `TEST`,
//             ucemMembershipGuid: `b4c51f9a-967d-f011-b4cc-6045bd1c3745`,
//             campaignCode: `Organic_Default_Campaign_0dollar`,
//             memberStartDate: `2025-08-01T00:00:00.000Z`,
//             paymentInstructionCode: 1,
//             paymentInstructionName: `ONE-TIME`,
//             paymentModeName: `ONLINE + TOKEN`,
//             paymentType: 100000001,
//             paymentTypeName: `CREDIT CARD RECURRING`,
//             paymentMode: `CREDIT CARD RECURRING`,
//             showPaymentOption: true,
//             union: {
//                 id: 417,
//                 code: `BFSU`,
//                 name: `Banking and Financial Services Union`,
//                 address: `200 Jalan Sultan\n#10-01 Textile Centre\nSingapore 199018`,
//                 tel: [
//                     `+6562952975`,
//                 ],
//                 fax: [
//                     `+6562968756`,
//                 ],
//                 website: `https://www.bfsu.org.sg/`,
//                 email: `bfsu@ntuc.org.sg`,
//                 about: [
//                     `Previously known as the Singapore Bank Officers' Association, the union changed its name and constitution in 2019.`,
//                     `Represents all persons employed in the banking and financial services industry and related services in Singapore.`,
//                 ],
//                 createdAt: `2022-03-22T15:52:01.997Z`,
//                 updatedAt: `2022-03-22T15:52:01.997Z`,
//                 publishedAt: `2022-03-22T15:52:01.992Z`,
//                 logo: {
//                     raw: `/uploads/BFSU_c9d721becb.png`,
//                     thumbnail: `/uploads/thumbnail_BFSU_c9d721becb.png`,
//                     small: `/uploads/small_BFSU_c9d721becb.png`,
//                     medium: `/uploads/medium_BFSU_c9d721becb.png`,
//                     large: `/uploads/large_BFSU_c9d721becb.png`,
//                 },
//             },
//         },
//         {
//             id: 4239,
//             createdDttm: `2025-06-17T03:07:24.167Z`,
//             membershipTypeCode: `GB`,
//             modifiedDttm: `2025-08-01T12:31:49.933Z`,
//             status: `ACTIVE`,
//             unionCode: `VICPA`,
//             unionName: `Visual, Audio, Creative Content Professionals Association (Singapore)`,
//             lastPaymentStartDate: `2025-06-01T00:00:00.000Z`,
//             lastPaymentEndDate: `2046-08-31T00:00:00.000Z`,
//             nameOnCard: `SumanaDXC-1`,
//             ucemMembershipGuid: `0ad24966-21f4-44f6-9e9d-a5fb9d9fcfaf`,
//             memberStartDate: `2025-04-01T00:00:00.000Z`,
//             paymentInstructionCode: -1,
//             paymentType: 100000001,
//             paymentTypeName: `CREDIT CARD RECURRING`,
//             paymentMode: `CREDIT CARD RECURRING`,
//             showPaymentOption: true,
//             union: {
//                 id: 474,
//                 code: `VICPA`,
//                 name: `VISUAL, AUDIO, CREATIVE CONTENT PROFESSIONALS ASSOCIATION`,
//                 address: `NTUC Centre\n1 Marina Boulevard, #10-01, One Marina Boulevard\nSingapore 018989.`,
//                 tel: [
//                     `+6562138008`,
//                 ],
//                 fax: null,
//                 website: `https://www.facebook.com/vicpasingapore/`,
//                 email: `vicpa@ntuc.org.sg`,
//                 about: [
//                     `Formed in July 2021, the Visual, Audio, Creative Content Professionals Association (Singapore) (VICPA) champions the interests of Singapore’s growing pool of freelance creative professionals.`,
//                 ],
//                 createdAt: `2022-03-22T15:54:24.351Z`,
//                 updatedAt: `2022-03-22T15:54:24.351Z`,
//                 publishedAt: `2022-03-22T15:54:24.348Z`,
//                 logo: {
//                     raw: `/uploads/VICPA_1b6e8384b4.png`,
//                     thumbnail: `/uploads/thumbnail_VICPA_1b6e8384b4.png`,
//                     small: `/uploads/small_VICPA_1b6e8384b4.png`,
//                     medium: `/uploads/medium_VICPA_1b6e8384b4.png`,
//                     large: `/uploads/large_VICPA_1b6e8384b4.png`,
//                 },
//             },
//         },
//         {
//             id: 3579,
//             createdDttm: `2025-06-17T03:07:24.167Z`,
//             membershipTypeCode: `GB`,
//             modifiedDttm: `2025-08-01T12:31:49.933Z`,
//             status: `ACTIVE`,
//             unionCode: `VICPA`,
//             unionName: `NTUC General Branch`,
//             lastPaymentStartDate: `2025-06-01T00:00:00.000Z`,
//             lastPaymentEndDate: `2046-08-31T00:00:00.000Z`,
//             nameOnCard: `SumanaDXC-1`,
//             ucemMembershipGuid: `0ad24966-21f4-44f6-9e9d-a5fb9d9fcfaf`,
//             memberStartDate: `2025-04-01T00:00:00.000Z`,
//             paymentInstructionCode: -1,
//             paymentType: 100000001,
//             paymentTypeName: `CREDIT CARD RECURRING`,
//             paymentMode: `CREDIT CARD RECURRING`,
//             showPaymentOption: true,
//             union: {
//                 id: 474,
//                 code: `VICPA`,
//                 name: `VISUAL, AUDIO, CREATIVE CONTENT PROFESSIONALS ASSOCIATION`,
//                 address: `NTUC Centre\n1 Marina Boulevard, #10-01, One Marina Boulevard\nSingapore 018989.`,
//                 tel: [
//                     `+6562138008`,
//                 ],
//                 fax: null,
//                 website: `https://www.facebook.com/vicpasingapore/`,
//                 email: `vicpa@ntuc.org.sg`,
//                 about: [
//                     `Formed in July 2021, the Visual, Audio, Creative Content Professionals Association (Singapore) (VICPA) champions the interests of Singapore’s growing pool of freelance creative professionals.`,
//                 ],
//                 createdAt: `2022-03-22T15:54:24.351Z`,
//                 updatedAt: `2022-03-22T15:54:24.351Z`,
//                 publishedAt: `2022-03-22T15:54:24.348Z`,
//                 logo: {
//                     raw: `/uploads/VICPA_1b6e8384b4.png`,
//                     thumbnail: `/uploads/thumbnail_NTUC_Hallmark_Red_ed8e454ead.png`,
//                     small: `/uploads/small_VICPA_1b6e8384b4.png`,
//                     medium: `/uploads/medium_VICPA_1b6e8384b4.png`,
//                     large: `/uploads/large_VICPA_1b6e8384b4.png`,
//                 },
//             },
//         },
//     ],
// }

function MembershipPaymentFlow() {
    const [cookies, setCookie] = useCookies()
    const [route, setRoute] = useState<MembershipPaymentRoute>(MembershipPaymentRoute.Main)
    const [originalRoute, setOriginalRoute] = useState<MembershipPaymentRoute>(MembershipPaymentRoute.Main)
    const [memberships, setMemberships] = useState<MembershipDetail[] | undefined>()
    const [isMembershipLoaded, setMembershipLoaded] = useState(false)

    useEffect(() => {
        if (window.myNtucConfig.recurringPaymentCallbackUrl != null && window.location.href.startsWith(window.myNtucConfig.recurringPaymentCallbackUrl)) {
            setRoute(MembershipPaymentRoute.Recurring)
            setOriginalRoute(MembershipPaymentRoute.Recurring)
        } else if (window.myNtucConfig.membershipPaymentCallbackUrl != null && window.location.href.startsWith(window.myNtucConfig.membershipPaymentCallbackUrl)) {
            setRoute(MembershipPaymentRoute.MembershipFeePayment)
            setOriginalRoute(MembershipPaymentRoute.MembershipFeePayment)
        }
    }, [])

    useEffect(() => {
        if (!memberships) {
            getMembershipDetails()
                .then((response) => response.content.memberships)
                .then(setMemberships)
                .then(() => setMembershipLoaded(true))
        }
    }, [])

    useEffect(() => {
        if (!isMembershipLoaded || !memberships) return
        //Has more than 1 memberships => redirect to Selection page
        if (memberships && memberships.length > 1 && route !== MembershipPaymentRoute.MembershipFeePayment && route !== MembershipPaymentRoute.Recurring) {
            setRoute(MembershipPaymentRoute.MembershipSelection)
        } else if (cookies && memberships && memberships.length === 1) {
            setCookie(AppCookies.MYNTUC_MEMBERSHIP_ID, memberships[0].id)
        }
    }, [isMembershipLoaded, memberships])

    const handleNavigateTo = (newRoute: MembershipPaymentRoute) => {
        setRoute(newRoute)
    }

    const LoadingBody = () => {
        return (
            <Grid container item justifyContent="center" py={6} xs={12}>
                <CircularProgress />
            </Grid>
        )
    }

    const currentPage = () => {

        if (window.myNtucConfig.authToken && (!isMembershipLoaded || !memberships)) {
            return <LoadingBody />
        }

        switch (route) {
            case MembershipPaymentRoute.Main:
                return <MembershipPaymentPage onNavigateTo={handleNavigateTo} />
            case MembershipPaymentRoute.Recurring:
                return <RecurringPaymentFlow onNavigateTo={handleNavigateTo} />
            case MembershipPaymentRoute.MembershipFeePayment:
                return <ArrearsPaymentFlow onNavigateTo={handleNavigateTo} />
            case MembershipPaymentRoute.RetryUpfrontPayment:
                return <ArrearsPaymentFlow onNavigateTo={handleNavigateTo} defaultRoute={ArrearsRoute.RetryUpfrontPayment} />
            case MembershipPaymentRoute.MembershipSelection:
                return <MembershipSelection onNavigateTo={handleNavigateTo} memberships={memberships} originalRoute={originalRoute} />
        }
    }

    return (
        <I18nextProvider i18n={i18config}>
            <ThemeProvider theme={theme}>
                <Container sx={{ backgroundColor: `white` }}>
                    <StoreProvider initialState={initialState} reducer={membershipReducer}>
                        {currentPage()}
                    </StoreProvider>
                </Container>
            </ThemeProvider>
        </I18nextProvider >
    )
}

export default MembershipPaymentFlow
export { MembershipPaymentRoute }